import { MetaReducer } from '@ngrx/store';

import { AppState } from '@core/state/interfaces';

import { clearState } from './clear-state.meta-reducer';
import { storageSyncReducer } from './storage-sync.meta-reducer';

// metareducers - these are run (right to left) in order
export const metaReducers: MetaReducer<AppState>[] = [storageSyncReducer, clearState];
